<div [ngStyle]="{ 'display' : this.cqaController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="fields__block">
    <div class="fields__block__section">
      <div class="table-fields">
        <div style="width: fit-content; margin: 0 auto;">
          <table style="display: block;width: 100%;">
            <thead>
              <tr>
                <th scope="col" style="width: 200px;">ID</th>
                <th scope="col" style="width: 200px;">No coverage</th>
                <th scope="col" style="width: 200px;">No Redundacy</th>
                <th scope="col" style="width: 200px;">Limited Redundacy</th>
                <th scope="col" style="width: 200px;">Full Redundacy</th>
                <th scope="col" style="width: 200px;">High Redundacy</th>
                <th scope="col" style="width: 200px;">Total Coverage</th>
              </tr>
            </thead>
            <tbody style="max-height: 325px; overflow-y: auto; display: block; width: 100%;">
              <tr mdbTableCol *ngFor="let id of this.cqaController.results">
                <td style="width: 200px;">{{id.type}}</td>
                <td *ngFor="let calc of id.values" style="width: 200px;" >{{calc}}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
  <div class="fields__btn" style="padding-left: 60px;">
    <button type="submit" [ngClass]="'blue'" (click)="exportToCsv()">
      Export to CSV
    </button>
    <button class="gray" (click)="this.tabsService.closeTab()">Cancel</button>
  </div>
</div>
